<template>
  <b-table hover :items="assInfo.items" head-variant="light" bordered></b-table>
</template>

<script>
import assInfo from "./chromAssbleInfo.json"

export default {
  data() {
    return {
      assInfo
    }
  }
}
</script>

<style scoped>
  /* table {
    font-size: calc(.73rem + .6vw)
  } */
  table {
    height: 36.85rem;
  }
</style>